import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzInputNumberModule } from "ng-zorro-antd/input-number";
import { NzListModule } from "ng-zorro-antd/list";
import { NzMessageModule } from "ng-zorro-antd/message";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzTagModule } from "ng-zorro-antd/tag";
import { SharedModule } from "../../shared/shared.module";
import { CustomerRiceInvoiceFormModule } from "../customers/customer-rice-invoice-form/customer-rice-invoice-form.module";
import { DocumentsListComponent } from "./documents-list/documents-list.component";
import { DocumentsPaymentsComponent } from "./documents-payments/documents-payments.component";

@NgModule({
  declarations: [DocumentsListComponent, DocumentsPaymentsComponent],
  imports: [
    NzModalModule,
    CommonModule,
    NzDividerModule,
    NzAvatarModule,
    NzDescriptionsModule,
    NzMessageModule,
    NzTagModule,
    NzDropDownModule,
    NzDatePickerModule,
    NzInputNumberModule,
    NzSpinModule,
    NzListModule,
    NzIconModule,
    NzCollapseModule,
    NzBadgeModule,
    NzTabsModule,
    SharedModule,
    RouterModule,
    NzTableModule,
    NzButtonModule,
    NzFormModule,
    NzSelectModule,
    NzInputModule,
    NzPopconfirmModule,
    FormsModule,
    CustomerRiceInvoiceFormModule,
  ],
  exports: [DocumentsListComponent, DocumentsPaymentsComponent],
})
export class DocumentssModule {}
